import { useTranslation } from 'react-i18next'

import { GavelIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Chip, Text } from '@reveni-io/reveni-ui'

import { actionTypes } from '@/configuration/pages/ConfigurationPage/ReturnPolicy/PolicyRulesConfiguration/PolicyRulesList/PolicyRuleItemList/PolicyRuleItem/constants'

import * as Styles from './styles'

const PolicyRuleAppliedItem = ({ rule, isDisabled }) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const actionConfig = actionTypes[rule.action]
  const textColor = isDisabled ? theme.colors.text.subtle : theme.colors.text.default

  return (
    <Styles.MainContainer>
      <Styles.Header>
        <GavelIcon size={24} color={textColor} />
        <Text type="bodyMBold" color={textColor}>
          {rule.internal_id} | {rule.name}
        </Text>
      </Styles.Header>
      {actionConfig && (
        <Styles.ChipContainer>
          <Chip
            label={t(actionConfig.labelKey)}
            Icon={actionConfig.icon}
            backgroundColor={theme.colors.info.surface}
            color={theme.colors.info.onSurface}
            disabled={isDisabled}
          />
        </Styles.ChipContainer>
      )}
    </Styles.MainContainer>
  )
}

export default PolicyRuleAppliedItem
